export default {
  BASE_URL: 'tender/',
  api: [
    {
      name: 'openTender',
      method: 'GET',
      desc: '检查是否能够投标并返回标书详情',
      path: 'openTender'
    },
    {
      name: 'getTenderOrgs',
      method: 'GET',
      desc: '获取投标供应商列表',
      path: 'getTenderOrgs'
    },
    {
      name: 'addTenderWhenInProcess',
      method: 'POST',
      desc: '中台添加投标单位',
      path: 'addTenderWhenInProcess'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/tender/add.js